import { api } from '../lib/api-client.js';

import type { CurrentUser } from '@sitewise/shared';


export interface Org {
  id: string;
  slug: string;
  name: string;
  logoUrl: string | null;
  primaryColorHex: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userCount?: number;
}

export async function fetchOrg(): Promise<{ org: Org }> {
  return api<{ org: Org }>('/org');
}

export async function updateOrgBranding(input: {
  name?: string;
  logoUrl?: string | null;
  primaryColorHex?: string | null;
}): Promise<{ org: Org }> {
  return api<{ org: Org }>('/org', { method: 'PATCH', body: input });
}

export async function listOrgUsers(): Promise<{ users: CurrentUser[] }> {
  return api<{ users: CurrentUser[] }>('/org/users');
}

export async function inviteOrgUser(input: {
  email: string;
  name: string;
  role: string;
}): Promise<{ user: CurrentUser }> {
  return api<{ user: CurrentUser }>('/org/users', { method: 'POST', body: input });
}

export async function updateOrgUserRole(
  id: string,
  role: string,
): Promise<{ user: CurrentUser }> {
  return api<{ user: CurrentUser }>(`/org/users/${id}`, {
    method: 'PATCH',
    body: { role },
  });
}

export async function updateOrgUserTabletMode(
  id: string,
  tabletMode: boolean,
): Promise<{ user: CurrentUser }> {
  return api<{ user: CurrentUser }>(`/org/users/${id}`, {
    method: 'PATCH',
    body: { tabletMode },
  });
}

export async function deactivateOrgUser(id: string): Promise<void> {
  await api(`/org/users/${id}`, { method: 'DELETE' });
}
